import './vendors/jquery-accessibleMegaMenu.js';

export function megamenu() {

    // Now $.fn.accessibleMegaMenu is available
    $('.megamenu').accessibleMegaMenu({
        menuClass: 'accessible-megamenu',
        topNavItemClass: 'accessible-megamenu-top-nav-item',
        panelClass: 'accessible-megamenu-panel',
        panelGroupClass: 'accessible-megamenu-panel-group',
    });

    //An item with an empty sub-menu should act as a plain link. The plugin
    //only intercepts clicks on items that contain a panel, so undo its
    //wiring on empty sub-menus: strip the panel class/attributes from the
    //div and the button semantics from the link.
    $('.megamenu .accessible-megamenu-top-nav-item').each(function() {
        const submenu = $(this).children('.sub-menu');
        if (submenu.length && !submenu.html().trim()) {
            submenu
                .removeClass('accessible-megamenu-panel')
                .removeAttr('role aria-hidden aria-labelledby');
            $(this).children('a')
                .removeAttr('role aria-controls aria-expanded tabindex');
        }
    });
    
    //Drive overlay, header class, and slide animation off panel .open changes
    const overlay = $('.site-overlay-dark');
    const slideDuration = 350;
    const slideEasing = 'swing';

    $('.accessible-megamenu-panel').each(function() {
        const panel = this;
        new MutationObserver(function(mutations) {
            const wasOpen = mutations.some(function(m) {
                return /\bopen\b/.test(m.oldValue || '');
            });
            const isOpen = panel.classList.contains('open');

            if (isOpen && !wasOpen) {
                //Inject promo images the first time this panel opens. The markup
                //holds the URL in data-src so nothing is fetched on page load;
                //removing the attribute makes this a one-time cost per panel.
                $(panel).find('img[data-src]').each(function() {
                    this.src = this.dataset.src;
                    this.removeAttribute('data-src');
                });

                //Opening: only ever show one panel — force every other panel closed
                const menuAlreadyActive = $('header').hasClass('megamenu-active');
                $('.accessible-megamenu-panel').not(panel)
                    .stop(true, true)
                    .hide()
                    .removeClass('open')
                    .attr('aria-hidden', 'true');

                if (menuAlreadyActive) {
                    //Menu already open: swap panels instantly, no overlapping slide
                    $(panel).stop(true, true).show();
                } else {
                    //First open: header class + overlay first, then slide panel down
                    $('header').addClass('megamenu-active');
                    overlay.stop(true, true).fadeIn(slideDuration);
                    $(panel).stop(true, true).slideDown(slideDuration, slideEasing);
                }
            } else if (!isOpen && wasOpen) {
                if ($('.accessible-megamenu-panel.open').length) {
                    //Another panel is taking over — hide this one immediately
                    $(panel).stop(true, true).hide();
                } else {
                    //Last panel: slide up first, then remove header class + overlay
                    $(panel).stop(true, true).slideUp(slideDuration, slideEasing, function() {
                        if (!$('.accessible-megamenu-panel.open').length) {
                            $('header').removeClass('megamenu-active');
                            //The search panel shares the overlay — leave it up
                            //if the search panel has taken over
                            if (!$('header').hasClass('search-active')) {
                                overlay.stop(true, true).fadeOut(slideDuration);
                            }
                        }
                    });
                }
            }
        }).observe(panel, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    });

    //Clicking the overlay just closes any open panel — the observer handles the rest
    overlay.on('click', function() {
        $('.accessible-megamenu-panel.open')
            .removeClass('open')
            .attr('aria-hidden', 'true');
        $('.accessible-megamenu-top-nav-item [aria-expanded=true]')
            .attr('aria-expanded', 'false')
            .removeClass('open');
    });

    //Clicking a megamenu link closes any open toolbar dropdown. The megamenu
    //plugin stops click propagation, so Bootstrap's outside-click close never fires.
    //Bound directly on the links so it runs before the plugin halts the event.
    $('.megamenu a').on('click', function() {
        if (typeof bootstrap === 'undefined') {
            return;
        }
        $('.dropdown-toggle').each(function() {
            const instance = bootstrap.Dropdown.getInstance(this);
            if (instance) {
                instance.hide();
            }
        });
    });

}